import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Partner, PartnerState } from '@fitscovery/partner/data-access';
import { Select } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { Metadata } from '@fitscovery/partner-web/shared/models';
import { MetaTagService } from '@fitscovery/partner-web/shared/services';
import { RegexProvider } from '@fitscovery/common/providers/regex';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'fitscovery-feature-partner-homepage',
  templateUrl: './feature-partner-homepage.component.html',
  styleUrls: ['./feature-partner-homepage.component.scss'],
})
export class FeaturePartnerHomepageComponent implements OnInit {
  @Select(PartnerState.partner) partner$: Observable<Partner | null>;
  private metaTitle = 'Fitscovery | Fitness | Fitness Discovery';

  partnerSubjectSource$: BehaviorSubject<Partner | null>;
  partnerSubject$: Observable<Partner | null>;

  isServer: boolean;
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private metaTagService: MetaTagService
  ) {
    this.isServer = isPlatformServer(this.platformId);
    this.isBrowser = isPlatformBrowser(this.platformId);

    this.partnerSubjectSource$ = new BehaviorSubject<Partner | null>(null);
    this.partnerSubject$ = this.partnerSubjectSource$.asObservable().pipe( filter(e => !!e) );
  }

  ngOnInit(): void {

    this.partner$.subscribe((partner) => {

      if (partner !== undefined && partner !== null) {
        this.setMetatag(partner);
      }

      if (this.isServer) {
        this.partnerSubjectSource$.next(partner);
      } 
      
      if (this.isBrowser) {
        this.partnerSubjectSource$.next(partner);
      }
      
    });
  }

  private setMetatag(partner: Partner): void {
    this.metaTitle = partner.name + ' | ' + this.metaTitle;
    this.metaTagService.setTitle(partner.name!);
    this.metaTagService.setTags(<Metadata>{
      site: partner.name,
      title: this.metaTitle,
      description: partner.textSections![2].text!.replace(RegexProvider.htmlTags, ' '),
      url: `https://${partner.subdomain}.fitscovery.com`,
      imageUrl: partner.bannerImage
    });
  }
}
